import { useQuery } from "@apollo/client";
import TranslationShowQuery from "../graphql/queries/TranslationShowQuery.graphql";
import TranslationEditQuery from "../graphql/queries/TranslationEditQuery.graphql";
import type {
  TranslationShowQueryType,
  TranslationEditQueryType,
} from "@/types/graphql/admin.generated";

export function useTranslationShowQuery(id: string | null, skip = false) {
  return useQuery<TranslationShowQueryType>(TranslationShowQuery, {
    variables: { id },
    skip: skip || !id,
  });
}

export function useTranslationEditQuery(id: string | null, skip = false) {
  return useQuery<TranslationEditQueryType>(TranslationEditQuery, {
    variables: { id },
    skip: skip || !id,
  });
}
